export const props = {
  // Values
  list: [Array, Object]
}
